import React from "react";
import { useLocation } from "react-router-dom";
import { Heading } from "../components/catalyst/heading";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
  BreadcrumbLink,
} from "../components/ui/breadcrumb";
import { Home, List, Route, Filter } from "lucide-react"; // Example icons

export function Header() {
  const location = useLocation();
  const { clusterId } =
    location.pathname.match(/\/itinerary\/(?<clusterId>[^/]+)/)?.groups || {};

  // Determine title based on route
  let pageTitle = "Generate Schedules"; // Default
  if (location.pathname === "/schedules") {
    pageTitle = "View Generated Schedules";
  } else if (clusterId) {
    pageTitle = `Schedule Details`; // Can be enhanced later to fetch name
  }
  else if (location.pathname === "/build-itinerary") {
    pageTitle = `Build Your Own Itinerary`; // Can be enhanced later to fetch name
  }
  else if (location.pathname === "/saved-schedules") {
    pageTitle = `Active Planned Schedules`; // Can be enhanced later to fetch name
  }
  else if (location.pathname === "/rsm-manager") {
    pageTitle = `Manage RSM Schedules`; // Can be enhanced later to fetch name
  }

  return (
    <header className="mb-6 ">
      {/* Breadcrumbs */}
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink href="/">
              <div className="flex items-center gap-1.5">
                <Filter className="h-4 w-4" /> Generate
              </div>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {location.pathname.startsWith("/schedules") && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink href="/schedules">
                  <div className="flex items-center gap-1.5">
                    <List className="h-4 w-4" /> View Schedules
                  </div>
                </BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}
          {clusterId && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>
                  <div className="flex items-center gap-1.5">
                    <Route className="h-4 w-4" /> Schedule {clusterId}
                  </div>
                </BreadcrumbPage>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>

      {/* Page Title */}
      <div className="border-b border-zinc-950/10 dark:border-white/10 pb-4">
        <Heading>{pageTitle}</Heading>
      </div>
      {/* Add any other header controls like user menu, notifications if needed */}
    </header>
  );
}
